import { readRowString } from './row-data.js';

export default {
    getRowKey($row) {
        const pledgeId = readRowString($row, 'pledge-id');
        if (pledgeId !== '') {
            return {
                type: 'pledge',
                id: pledgeId,
                tableName: readRowString($row, 'table-name'),
            };
        }
        const memberId = readRowString($row, 'member-id');
        if (memberId !== '') {
            return { type: 'member', id: memberId };
        }
        return null;
    },

    getPledgeRowSelector(pledgeId, tableName) {
        if (tableName) {
            return `.clickable-row[data-pledge-id="${pledgeId}"][data-table-name="${tableName}"]`;
        }
        return `.clickable-row[data-pledge-id="${pledgeId}"]`;
    },
};
